import IconNext from "../../icons/icon-next/icon-next";
import Icon from "../../icons/icon/icon";
import {ICollapsibleArrowProps} from "../collapsible.types";
import './trigger-arrow.scss';

export const TriggerArrow: React.FC<ICollapsibleArrowProps> = ({isExpanded}) => (
    <div className={`collapsible-trigger-arrow ${isExpanded ? 'is-expanded' : ''}`}>
        <Icon color={'var(--color-accent-1)'} Component={IconNext} />
    </div>
);